import React from 'react';
import { useCurrentAppContext } from '../../../utils/useCurrentAppContext';
import { InputNumber } from '../../elements';

interface IEditPanelInputNumberProps {
    placeholder?: string | undefined;
    name: string;
    value?: number | undefined;
    unit?: string | undefined;
    onChange: (value: number | null) => void;
    onBlur?: (isChanged: boolean) => Promise<void>;
}

export function EditPanelInputNumber(props: IEditPanelInputNumberProps) {
    const appContext = useCurrentAppContext();

    const decimalSeparator = appContext.languageCode === 'nl' ? ',' : '.';
    return <InputNumber {...props} decimalSeparator={decimalSeparator} className="gui-input" />;
}
